export default __webpack_public_path__ + "static/media/pinkFlowers.a94949e5.jpg";